





import { Vue ,Prop, Watch, Component } from "vue-property-decorator";

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue {

    @Prop()
    public value: any;

    @Watch( 'value', { immediate: true } )
    onIndex() {
        this.Selected = this.value;
    }


    @Prop( { type: Boolean} )
    public Abierto: boolean;

    @Watch( 'Abierto')
    onAbierto() {
        document.getElementById( 'aInput' )?.click();
    }


    constructor() {
        super();
    }

    public selected: any | null = null;
    public get Selected(): any | null {
        return this.selected;
    }
    public set Selected( x: any | null ) {
        this.selected = x;
        this.$emit( 'input', this.Selected );
        this.$emit( 'change', this.Selected );
    }


    public async buscar() {

    }

    public Archivo: any = null;


}
